import {MAX_PAGE} from './store-selection';

// Keep this policy aligned with WebFrontEnd/services/store/SpecializedStoreCanonical.cs.
const FACET_PARAMETERS = new Set(['s', 't', 'ft', 'finish', 'mat', 'min', 'max', 'sort', 'year']);

/** Retain the server's portal domain and prefiltered route; only the accepted plain page changes. */
export function storeCanonicalForSearch(existingCanonical: string, acceptedSearch: string): string {
    const [path, existingSearch = ''] = existingCanonical.split('#', 1)[0].split('?', 2);
    const canonicalQuery = new URLSearchParams(existingSearch);
    canonicalQuery.delete('page');
    const base = path + (canonicalQuery.size ? `?${canonicalQuery}` : '');
    const selection = new URLSearchParams(acceptedSearch);
    for (const [name, value] of selection) {
        if (FACET_PARAMETERS.has(name) && value.length > 0) return base;
    }

    const pageText = selection.get('page') || '';
    const page = Number(pageText);
    if (!/^\d+$/.test(pageText) || page < 2 || page > MAX_PAGE) return base;

    canonicalQuery.set('page', String(page));
    return `${path}?${canonicalQuery}`;
}

export function syncStoreCanonical(acceptedSearch: string) {
    if (typeof document === 'undefined') return;
    const link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const current = link?.getAttribute('href');
    if (!link || !current) return;
    const next = storeCanonicalForSearch(current, acceptedSearch);
    if (next !== current) link.setAttribute('href', next);
}
